import { styleVariants } from '@vtex/admin-ui'

export const buildProductImageContainerVariants = ({
  imageSize = 2.75,
  containerSize = 2.75,
} = {}) =>
  styleVariants({
    type: {
      fallback: {
        size: `${imageSize}rem`,
        minHeight: `${imageSize}rem`,
        maxHeight: `${imageSize}rem`,
        minWidth: `${imageSize}rem`,
        maxWidth: `${imageSize}rem`,
        marginX: `max(calc(${(containerSize - imageSize) / 2}rem), 0px)`,
        borderRadius: '$base',
        boxSizing: 'content-box',
        border: `2px solid $white`,
        fg: '$disabled',
        bg: '$secondary',
      },
      image: {
        size: `${imageSize}rem`,
        minHeight: `${imageSize}rem`,
        maxHeight: `${imageSize}rem`,
        minWidth: `${imageSize}rem`,
        maxWidth: `${imageSize}rem`,
        marginX: `max(calc(${(containerSize - imageSize) / 2}rem), 0px)`,
        boxSizing: 'content-box',
        borderRadius: '$base',
        border: `2px solid $white`,
        overflow: 'hidden',
        '> *': {
          size: `${imageSize}rem`,
          minHeight: `${imageSize}rem`,
          maxHeight: `${imageSize}rem`,
          minWidth: `${imageSize}rem`,
          maxWidth: `${imageSize}rem`,
        },
      },
    },
  })
